import { getRequest, postRequest, patchRequest, deleteRequest, getRequestWithMoreOptions } from '../utils/request'

// employees
export const postEmployeeProfilePicture = async (id, data) => postRequest(`/v1/employees/${id}/profile-picture`, data)
export const getEmployeeProfilePicture = async (id, queryParams) => getRequestWithMoreOptions(`/v1/employees/${id}/profile-picture`, {
  params: queryParams,
  responseType: "arraybuffer",
  responseEncoding: "base64",
})
export const deleteEmployeeProfilePicture = async (id) => deleteRequest(`/v1/employees/${id}/profile-picture`)

// students
export const postStudentProfilePicture = async (id, data) => postRequest(`/v1/students/${id}/profile-picture`, data)
export const getStudentProfilePicture = async (id, queryParams) => getRequestWithMoreOptions(`/v1/students/${id}/profile-picture`, {
  params: queryParams,
  responseType: "arraybuffer",
  responseEncoding: "base64",
})
export const deleteStudentProfilePicture = async (id) => deleteRequest(`/v1/students/${id}/profile-picture`)
